import axios from "axios";
import { Toast } from "./toast";
import Modal from "component/Common/LoaderModal";
import { history } from "helpers";
import endpoints from "./endpoints";
import { getbaseUrl } from "./baserul";

export const request = ({
  url,
  method = endpoints.APIMethods.GET,
  data,
  isLoader = true,
  baseUrl = "orders",
  params,
  source = "WEB",
  responseType,
  isShowMessage = true,
  excelType
}) =>
  new Promise((resolve, reject) => {
    let token = localStorage.getItem("token");
    let queryParams = params;
    // if (params?.search !== "" && params?.page) {
    //   queryParams.page = 1;
    // }
    let config = {
      url: getbaseUrl(baseUrl) + url,
      method: method,
      params: queryParams ? queryParams : null,
      data: data ? data : null,
      headers: {
        Authorization: token ? "" + token : "",
        "Content-Type": "application/json",
        source,
        excelType
      },
    };

    config.params == null && delete config.params;
    config.data == null && delete config.data;

    if (responseType) config.responseType = responseType;

    showLoader(isLoader);

    axios(config)
      .then((response) => {
        let {
          status,
          data: { message },
        } = response;
        showLoader(false);
        method !== "GET" &&
          isShowMessage &&
          Toast({ type: "success", message: message });
        if (status === 401) {
          history.replace("/auth/login");
          localStorage.clear();
        }
        return resolve(response);
      })
      .catch(({ response }) => {
        showLoader(false);
        if (response) {
          console.log(response, "errorred");
          let {
            status,
            data: { message },
          } = response;
          isShowMessage && Toast({ type: "error", message: message });

          if (status === 401) {
            history.replace("/auth/login");
            localStorage.clear();
          }
        } else {
          Toast({
            type: "error",
            message: "Not able to connect the server. Please try again later",
          });
        }

        return reject(response);
      });
  });

export const showLoader = (status) => {
  if (Modal && Modal.render && Modal.render.defaultProps) {
    Modal.render.defaultProps.setLoaderStatus(status);
  }
};
